export default __webpack_public_path__ + "static/media/JCB.b3164d73.svg";